import Immutable from 'immutable';

export default class Interval extends Immutable.Record({
  start: undefined,
  end: undefined,
}) { }



// WEBPACK FOOTER //
// ./domain/Interval/model.js